import ComplaintTypeTable from 'components/complainttype/ComplaintTypeTable';
import React from 'react';

const ComplaintType = () => {
  return <ComplaintTypeTable />;
};

export default ComplaintType;
